var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145.9mm",
    height: "111.88mm",
    viewBox: "0 0 145.9 111.88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10015"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10043"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 1.831e-4",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10053"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 1.831e-4",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10063"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10073"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10099"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m419.25 278.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10165"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m343.29 158.93 69.66-18.24-18.24-69.652-69.66 18.24z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10199"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m587.25 282.75h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10209"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10237"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10281"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10291"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10301"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 1.2207e-4",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 1.2207e-4",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10321"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m492.68 156.71 69.65-18.24-18.24-69.655-69.65 18.24z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-621.39 -433.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 527.65 564.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m265.71 55.714h413.57v317.14h-413.57z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10015)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,495.55)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 20.224051 36.01395 48.0186 59.30225 76.570198 88.574852 116.3694 126.85995 144.88495 160.67485 177.94279 193.7327 209.5226 220.01315 232.01781 249.32179 267.3468 277.11636 286.12885 303.39679 319.18671",
    y: 0
  }, "Perform dance routines"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10027)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,352.47,495.55)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 12.00465 37.528049",
    y: 0
  }, "(A)"))), /*#__PURE__*/React.createElement("path", {
    d: "m313.13 240.75c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.13 240.75c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.55 202.34-13.25 10.88-28.42-34.62 13.25-10.88z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.55 202.34-13.25 10.88-28.42-34.62 13.25-10.88z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m378.67 214.42-16.27-5.38 14.07-42.52 16.27 5.39z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m378.67 214.42-16.27-5.38 14.07-42.52 16.27 5.39z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m335.63 251.25c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.63 251.25c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.88 251.25c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.88 251.25c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m355.32 248.94c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95c0 1.07 0.87 1.95 1.95 1.95s1.95-0.88 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.25 249.13c0-1.07-0.87-1.94-1.95-1.94-1.07 0-1.94 0.87-1.94 1.94 0 1.08 0.87 1.95 1.94 1.95 1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.63 284.62 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m335.63 284.62 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m317.11 225.42-13.49 4.26c-7.44 2.36-12.32 7.94-10.89 12.47 1.43 4.52 8.63 6.28 16.08 3.93l13.48-4.27z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m317.11 225.42-13.49 4.26c-7.44 2.36-12.32 7.94-10.89 12.47 1.43 4.52 8.63 6.28 16.08 3.93l13.48-4.27z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m396.29 238.6 16.44 10.59c9.07 5.85 19.01 6.59 22.2 1.64 3.18-4.94-1.59-13.69-10.66-19.54l-16.44-10.59z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m396.29 238.6 16.44 10.59c9.07 5.85 19.01 6.59 22.2 1.64 3.18-4.94-1.59-13.69-10.66-19.54l-16.44-10.59z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m378.38 224.63c0-5.39-7.22-9.76-16.13-9.76s-16.12 4.37-16.12 9.76h4.87c0-2.7 5.04-4.88 11.25-4.88s11.25 2.18 11.25 4.88z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.38 224.63c0-5.39-7.22-9.76-16.13-9.76s-16.12 4.37-16.12 9.76h4.87c0-2.7 5.04-4.88 11.25-4.88s11.25 2.18 11.25 4.88z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10143)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.25,278.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10153)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.331 46.356-27-6.398v-22.342c-1.506 0.3-3.066 0.167-4.5-0.383-3.255-1.185-5.25-3.9-4.5-6.067 0.75-2.1675 4.058-3 7.313-1.7925 2.94 1.0645 4.62 3.7495 4.62 5.4145v21.638l21 4.957v-18.825c-1.538 0.31-3.133 0.175-4.598-0.39-3.33-1.222-5.385-4.02-4.575-6.262 0.81-2.243 4.163-3.068 7.5-1.853 2.82 1.013 4.695 3.105 4.793 5.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.569 59.316c-0.66 0.431-1.212 1.008-1.613 1.687v1.38c0 0.829-0.671 1.5-1.5 1.5-0.828 0-1.5-0.671-1.5-1.5v-22.642c-1.45 0.256-2.943 0.113-4.32-0.413-3.255-1.177-5.25-3.892-4.5-6.067s4.065-3 7.32-1.793c2.25 0.825 3.915 2.393 4.448 4.005v15.818c0.203-0.159 0.416-0.304 0.637-0.435 5.003-3 2.25-7.74 4.695-7.763 3.143-0.022 3.27 11.595-3.667 16.223z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.96738 .25334 -.25334 -.96738 412.95 140.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10175)",
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.991 14.578c0.171-1.772 0.484-3.528 0.938-5.2495l0.322-1.155c0.653-2.61 3.675-3.285 5.865-2.655l1.155 0.33c2.225 0.5773 3.565 2.8425 3 5.0695l-0.322 1.155c-0.467 1.745-1.113 3.436-1.928 5.048l-9-2.513z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.679 17.856 9.307 2.505c-2.04 7.695 4.935 12.75-1.889 21.157-1.387 1.926-3.791 2.836-6.106 2.31-2.798-0.524-4.984-2.719-5.497-5.52-1.05-6 0.157-13.5 4.185-20.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.681 38.616c-0.506-1.769-1.153-3.494-1.935-5.16l-0.54-1.103c-1.14-2.512-4.32-2.632-6.412-1.582l-1.103 0.54c-2.118 1.012-3.035 3.534-2.062 5.67l0.547 1.102c0.796 1.675 1.761 3.263 2.88 4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.819 42.366-8.685 4.14c3.375 7.14-2.55 13.432 5.685 20.475 1.713 1.642 4.243 2.097 6.42 1.155 2.654-1.023 4.402-3.576 4.395-6.42-0.053-6.09-2.595-13.223-7.815-19.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.071 8.991 1.058-4.3725c2.229 0.5362 4.332 1.4989 6.195 2.835l-2.61 3.6595c-1.398-0.996-2.974-1.7162-4.643-2.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.634 12.801 3.255-3.105c1.583 1.658 2.835 3.603 3.69 5.73l-4.178 1.672c-0.642-1.594-1.581-3.053-2.767-4.297z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.466 9.366-1.5-4.2525c1.903-0.6613 3.904-0.9985 5.918-0.9975h0.855l-0.21 4.5c-1.72-0.0723-3.438 0.1822-5.063 0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.884 21.366-8.25 8.25-8.25-8.25h6c-0.026-0.606-0.094-1.21-0.203-1.808l4.418-0.847c0.159 0.877 0.254 1.764 0.285 2.655z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10199)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(587.25,282.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10209)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.331 46.356-27-6.398v-22.342c-1.506 0.3-3.066 0.167-4.5-0.383-3.255-1.185-5.25-3.9-4.5-6.067 0.75-2.1675 4.058-3 7.313-1.7925 2.94 1.0645 4.62 3.7495 4.62 5.4145v21.638l21 4.957v-18.825c-1.538 0.31-3.133 0.175-4.598-0.39-3.33-1.222-5.385-4.02-4.575-6.262 0.81-2.243 4.163-3.068 7.5-1.853 2.82 1.013 4.695 3.105 4.793 5.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.569 59.316c-0.66 0.431-1.212 1.008-1.613 1.687v1.38c0 0.829-0.671 1.5-1.5 1.5-0.828 0-1.5-0.671-1.5-1.5v-22.642c-1.45 0.256-2.943 0.113-4.32-0.413-3.255-1.177-5.25-3.892-4.5-6.067s4.065-3 7.32-1.793c2.25 0.825 3.915 2.393 4.448 4.005v15.818c0.203-0.159 0.416-0.304 0.637-0.435 5.003-3 2.25-7.74 4.695-7.763 3.143-0.022 3.27 11.595-3.667 16.223z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m484.88 227.25c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m484.88 227.25c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.63 237.75c0 8.91 7.72 16.12 17.25 16.12 9.52 0 17.25-7.21 17.25-16.12s-7.73-16.13-17.25-16.13c-9.53 0-17.25 7.22-17.25 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.63 237.75c0 8.91 7.72 16.12 17.25 16.12 9.52 0 17.25-7.21 17.25-16.12s-7.73-16.13-17.25-16.13c-9.53 0-17.25 7.22-17.25 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.88 237.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.88 237.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.73 235.41c0-1.07-0.87-1.94-1.95-1.94s-1.95 0.87-1.95 1.94c0 1.08 0.87 1.95 1.95 1.95s1.95-0.87 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.66 235.61c0-1.07-0.87-1.95-1.94-1.95-1.08 0-1.95 0.88-1.95 1.95 0 1.08 0.87 1.95 1.95 1.95 1.07 0 1.94-0.87 1.94-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m488.5 211.88-13.48 4.26c-7.45 2.36-12.32 7.94-10.89 12.46 1.43 4.53 8.63 6.29 16.08 3.94l13.48-4.27z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m488.5 211.88-13.48 4.26c-7.45 2.36-12.32 7.94-10.89 12.46 1.43 4.53 8.63 6.29 16.08 3.94l13.48-4.27z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m578.6 221.37 16.77-10.05c9.26-5.55 14.32-14.14 11.29-19.18-3.02-5.05-12.98-4.64-22.24 0.91l-16.77 10.05z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m578.6 221.37 16.77-10.05c9.26-5.55 14.32-14.14 11.29-19.18-3.02-5.05-12.98-4.64-22.24 0.91l-16.77 10.05z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m545.63 208.5c0-5.18-4.54-9.38-10.13-9.38s-10.12 4.2-10.12 9.38h4.68c0-2.59 2.44-4.69 5.44-4.69s5.44 2.1 5.44 4.69z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.63 208.5c0-5.18-4.54-9.38-10.13-9.38s-10.12 4.2-10.12 9.38h4.68c0-2.59 2.44-4.69 5.44-4.69s5.44 2.1 5.44 4.69z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m556.44 199.28-16.27-5.39 14.07-42.52 16.27 5.39z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m556.44 199.28-16.27-5.39 14.07-42.52 16.27 5.39z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m540.06 187.2-12.39 11.84-30.95-32.37 12.39-11.85z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m540.06 187.2-12.39 11.84-30.95-32.37 12.39-11.85z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10321)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.96738 .25334 -.25334 -.96738 562.33 138.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath10331)",
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.991 14.578c0.171-1.772 0.484-3.528 0.938-5.2495l0.322-1.155c0.653-2.61 3.675-3.285 5.865-2.655l1.155 0.33c2.225 0.5773 3.565 2.8425 3 5.0695l-0.322 1.155c-0.467 1.745-1.113 3.436-1.928 5.048l-9-2.513z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.679 17.856 9.307 2.505c-2.04 7.695 4.935 12.75-1.889 21.157-1.387 1.926-3.791 2.836-6.106 2.31-2.798-0.524-4.984-2.719-5.497-5.52-1.05-6 0.157-13.5 4.185-20.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.681 38.616c-0.506-1.769-1.153-3.494-1.935-5.16l-0.54-1.103c-1.14-2.512-4.32-2.632-6.412-1.582l-1.103 0.54c-2.118 1.012-3.035 3.534-2.062 5.67l0.547 1.102c0.796 1.675 1.761 3.263 2.88 4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.819 42.366-8.685 4.14c3.375 7.14-2.55 13.432 5.685 20.475 1.713 1.642 4.243 2.097 6.42 1.155 2.654-1.023 4.402-3.576 4.395-6.42-0.053-6.09-2.595-13.223-7.815-19.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.071 8.991 1.058-4.3725c2.229 0.5362 4.332 1.4989 6.195 2.835l-2.61 3.6595c-1.398-0.996-2.974-1.7162-4.643-2.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.634 12.801 3.255-3.105c1.583 1.658 2.835 3.603 3.69 5.73l-4.178 1.672c-0.642-1.594-1.581-3.053-2.767-4.297z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.466 9.366-1.5-4.2525c1.903-0.6613 3.904-0.9985 5.918-0.9975h0.855l-0.21 4.5c-1.72-0.0723-3.438 0.1822-5.063 0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.884 21.366-8.25 8.25-8.25-8.25h6c-0.026-0.606-0.094-1.21-0.203-1.808l4.418-0.847c0.159 0.877 0.254 1.764 0.285 2.655z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.f695a66af83c88427080f88ed60b01c5.svg";
export { ForwardRef as ReactComponent };